import { render, staticRenderFns } from "./scan.vue?vue&type=template&id=bcdd42d8&scoped=true&"
import script from "./scan.vue?vue&type=script&lang=js&"
export * from "./scan.vue?vue&type=script&lang=js&"
import style0 from "./scan.vue?vue&type=style&index=0&id=bcdd42d8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdd42d8",
  null
  
)

export default component.exports